"use client";
import { getCurrentPrice } from "@/config/affiliate";
import Link from "next/link";

const PostJob = ({ isUserLoggedIn }: { isUserLoggedIn: boolean }) => {
  if (isUserLoggedIn) {
    return (
      <Link
        href="/submit/job"
        className="btn btn-md mx-auto inline-flex max-w-xl items-center rounded-md border border-slate-400 bg-gradient-to-r from-purple-500 to-indigo-500 px-6 py-2 text-white transition-all duration-700  ease-linear hover:from-pink-500 hover:to-blue-500"
      >
        <span className="bold">Post a job for ${getCurrentPrice()}</span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="2"
          stroke="currentColor"
          className="h-5 w-5 animate-bounce"
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 13.5 12 21m0 0-7.5-7.5M12 21V3"></path>
        </svg>
      </Link>
    );
  }
  return (
    <>
      <button
        // @ts-ignore
        onClick={() => document?.getElementById("job_login_modal")?.showModal()}
        className="btn btn-md mx-auto inline-flex max-w-xl items-center rounded-md border border-slate-400 bg-gradient-to-r from-purple-500 to-indigo-500 px-6 py-2 text-white transition-all duration-700  ease-linear hover:from-pink-500 hover:to-blue-500"
      >
        <span className="bold">Post a job for ${getCurrentPrice()}</span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="2"
          stroke="currentColor"
          className="h-5 w-5 animate-bounce"
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 13.5 12 21m0 0-7.5-7.5M12 21V3"></path>
        </svg>
      </button>
      <dialog id="job_login_modal" className="modal">
        <div className="modal-box text-center">
          <h3 className="py-4 text-lg font-semibold">Please Login to post job, press below button to continue</h3>
          <Link
            href="/submit/job"
            className="btn btn-lg skeleton mx-auto my-5 inline-flex max-w-xl items-center rounded-md border border-slate-400 "
          >
            <span className="bold">Continue with Login</span>
          </Link>
        </div>
        <form method="dialog" className="modal-backdrop">
          <button>close</button>
        </form>
      </dialog>
    </>
  );
};

export default PostJob;
